import React, { ReactElement, useEffect, useState } from 'react';
import { ColorResult, SketchPicker } from 'react-color';
import { Button, CloseIcon, EditOutlinedIcon, Input } from 'elmo-elements';
import { addHashOnHex, invertColorBW } from '@/lib/util';
import './ColourPicker.scss';

interface ColourPickerPropsType {
  // eslint-disable-next-line react/require-default-props
  id?: string;
  defaultColor: string;
  handleChange: (e: any) => void;
  register: any;
  registerName: string;
  // eslint-disable-next-line react/require-default-props
  isFloat?: boolean;
  watch: any;
  placement?: 'top' | 'bottom';
}

const ColourPicker = ({
  id,
  defaultColor,
  handleChange,
  register,
  registerName,
  isFloat,
  placement = 'top',
}: ColourPickerPropsType): ReactElement => {
  const [showColourPicker, setShowColourPicker] = useState(false);
  const [colour, setColour] = useState(defaultColor || '#ffffff');

  const handleClick = () => {
    setShowColourPicker(!showColourPicker);
  };

  const handleClose = () => {
    setShowColourPicker(false);
  };

  const handleInputChange = (e: any) => {
    setColour(e.target.value);
    handleChange(e.target.value);
  };

  const handleColourChange = (sketchColourObject: ColorResult) => {
    setColour(sketchColourObject.hex);
    handleChange(sketchColourObject.hex);
  };

  const handleColourPickerOnBlur = (
    event: React.FocusEvent<HTMLDivElement>,
  ) => {
    if (
      event.relatedTarget &&
      event.currentTarget.contains(event.relatedTarget)
    ) {
      return;
    }
    handleClose();
  };

  useEffect(() => {
    if (defaultColor) {
      setColour(addHashOnHex(defaultColor));
    }
  }, [defaultColor]);

  return (
    <div
      className={`colour-picker__base ${
        isFloat && 'colour-picker__base--is-float'
      } is-place-${placement}`}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      onBlur={handleColourPickerOnBlur}
    >
      <Input
        id={id}
        {...register(registerName, {})}
        onChange={handleInputChange}
        value={colour}
        inputAdornmentEnd={
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <div className="colour-picker__swatch" onClick={handleClick}>
            <div
              className="colour-picker__colour"
              style={{
                backgroundColor: colour,
                color: invertColorBW(colour),
              }}
            >
              <EditOutlinedIcon />
            </div>
          </div>
        }
      />
      {showColourPicker ? (
        <div>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div className="colour-picker__wrapper">
            <Button
              isCircular={true}
              icon={<CloseIcon />}
              onClick={handleClose}
            />
          </div>
          <SketchPicker color={colour} onChange={handleColourChange} />
        </div>
      ) : null}
    </div>
  );
};

export default ColourPicker;
